import { graphql } from "../../graphql"

export type Journey = { id: string; title: string | null; isLocked: boolean }

export const query = graphql(`
  query ActiveJourney {
    nextJourney {
      id
    }
    # TODO [WEB-17784] "limit: 1000" is a temporary workaround for
    # journey navigation so I am not blocking myself. I'm working on
    # a proper GraphQL field handling navigation and will replace this
    # with the new one in ~2 weeks.
    productCategories(isJourney: true, limit: 1000, page: 1) {
      nodes {
        id
        title
        isLocked
      }
    }
  }
`)
